import React from "react";
import {
  makeStyles,
  DialogTitle,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
} from "@material-ui/core";
import config from "../../config";

const styles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  flex: {
    flex: 1,
  },
  imgContainer: {
    position: "relative",
    flex: 1,
    padding: 16,
    display: "grid",
    justifyContent: "center",
    alignItems: "center",
  },
  img: {
    maxWidth: "100%",
    maxHeight: "100%",
    border: "1px solid",
  },
}));

export default function DialogTrips(props) {
  const {
    open,
    onClose,
    title,
    question,
    load_id,
    type,
    dispatch,
    fetchRequest,
  } = props;
  const classes = styles();

  const handlePositiveClick = () => {
    const dataArray = [];
    if (type === 1) {
      const object = {
        load_id: load_id,
        pickup_address_wrong: 1,
      };
      dataArray.push(object);
    } else {
      const object = {
        load_id: load_id,
        delivery_address_wrong: 1,
      };
      dataArray.push(object);
    }

    dispatch(
      fetchRequest(
        `${config.API_URL}/_services/set_data.php`,
        dataArray,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
        "POST"
      )
    );
  };

  const handleNegativeClick = () => {
    onClose();
  };

  return (
    <Dialog
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      open={open}
      onClose={onClose}
      fullWidth={true}
      maxWidth='xl'
    >
      <DialogTitle
        id='alert-dialog-title'
        style={{ backgroundColor: "#fafafa" }}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        <div className={classes.imgContainer}>
          {question}
          <br />
        </div>
      </DialogContent>
      <DialogActions style={{ color: "white", backgroundColor: "#fafafa" }}>
        <Button
          variant='contained'
          onClick={handlePositiveClick}
          style={{ background: "#fafafa" }}
        >
          OK
        </Button>
        <Button
          variant='contained'
          onClick={handleNegativeClick}
          style={{ background: "#fafafa" }}
        >
          NO
        </Button>
      </DialogActions>
    </Dialog>
  );
}
